import { createSelector } from 'reselect';
import _ from 'lodash';
import { getGroupId } from './eventInfo';
import { getAssetState, getDetailPageEventState } from './index';

export const getEpgInfo = createSelector(
  [getDetailPageEventState],
  detailPageState => _.get(detailPageState, 'epgChannel', {}),
);

export const getChannels = createSelector(
  [getEpgInfo],
  epgInfo => _.get(epgInfo, 'model.channels', []),
);

export const getChannelEvents = createSelector(
  [getChannels, getGroupId],
  (channels, groupId) =>
    channels.find(ch => parseInt(ch.group_id, 10) === groupId),
);

export const getChannelMetadata = createSelector(
  [getChannelEvents],
  channel => _.get(channel, 'group.common', null),
);

export const getChannelInfo = createSelector(
  [getChannelMetadata],
  channel => ({
    image_large: _.get(channel, 'image_large', ''),
    image_medium: _.get(channel, 'image_medium', ''),
    groupId: _.get(channel, 'id'),
    format_types: _.get(channel, 'format_types', false),
    proveedor_name: _.get(channel, 'proveedor_name', false),
    live_enabled: _.get(channel, 'live_enabled', false),
    title: _.get(channel, 'title', ''),
  }),
);

export const getAssetBarRecord = createSelector(
  [getAssetState],
  asset => _.get(asset, 'npvr_record_asset_status', ''),
);
